function closestVariantPicker(el) {
  return el?.closest?.("variant-picker") || el?.closest?.(".product-info__variant-picker") || null;
}

function buildNote({ productTitle, productHandle, sizeLabel }) {
  const parts = [];
  if (productTitle) parts.push(`Product: ${productTitle}`);
  if (productHandle) parts.push(`Handle: ${productHandle}`);
  if (sizeLabel) parts.push(`Requested size: ${sizeLabel}`);
  parts.push(`URL: ${window.location.href}`);
  return parts.join(" | ");
}

function openDrawerById(id) {
  const drawer = document.getElementById(id);
  if (!drawer) return;
  drawer.show?.();
}

function onBisTriggerClick(e) {
  const trigger = e.target.closest("[data-bis-trigger]");
  if (!trigger) return;

  // Theme toggles .is-disabled when other options (e.g. Color) change — only intercept true OOS clicks
  if (!trigger.classList.contains("is-disabled")) return;

  // Disabled radio: open notify drawer instead of selection
  e.preventDefault();
  e.stopPropagation();

  const drawerId = trigger.getAttribute("data-bis-drawer");
  const sizeLabel = trigger.getAttribute("data-bis-size") || "";
  const productHandle = trigger.getAttribute("data-bis-product-handle") || "";
  const productTitle = trigger.getAttribute("data-bis-product-title") || "";

  const drawer = drawerId ? document.getElementById(drawerId) : null;
  if (drawer) {
    const note = drawer.querySelector("[data-bis-note]");
    const summary = drawer.querySelector("[data-bis-summary]");
    if (summary) {
      summary.textContent = [productTitle, sizeLabel ? `Size: ${sizeLabel}` : ""].filter(Boolean).join(" — ");
    }
    if (note) {
      note.value = buildNote({ productTitle, productHandle, sizeLabel });
    }
  }

  openDrawerById(drawerId);
}

document.addEventListener("click", onBisTriggerClick, { capture: true });

